var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoticeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.8463 3.34054C57.7469 1.31066 63.2531 1.31066 68.1537 3.34054L95.2727 14.5736C100.173 16.6035 104.067 20.497 106.097 25.3976L117.33 52.5166C119.36 57.4172 119.36 62.9234 117.33 67.824L106.097 94.943C104.067 99.8436 100.173 103.737 95.2727 105.767L68.1537 117C63.2531 119.03 57.7469 119.03 52.8463 117L25.7273 105.767C20.8267 103.737 16.9332 99.8436 14.9033 94.943L3.67025 67.824C1.64038 62.9234 1.64037 57.4172 3.67025 52.5166L14.9033 25.3976C16.9332 20.497 20.8267 16.6035 25.7273 14.5736L52.8463 3.34054Z",
    fill: "#E02020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8463 13.3405C57.7469 11.3107 63.2531 11.3107 68.1537 13.3405L88.2017 21.6447C93.1022 23.6746 96.9957 27.5681 99.0256 32.4686L107.33 52.5166C109.36 57.4172 109.36 62.9234 107.33 67.824L99.0256 87.872C96.9957 92.7725 93.1022 96.666 88.2017 98.6959L68.1537 107C63.2531 109.03 57.7469 109.03 52.8463 107L32.7983 98.6959C27.8978 96.666 24.0043 92.7725 21.9744 87.872L13.6703 67.824C11.6404 62.9234 11.6404 57.4172 13.6703 52.5166L21.9744 32.4686C24.0043 27.5681 27.8978 23.6746 32.7983 21.6447L52.8463 13.3405Z",
    fill: "#FD561F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4033 72.939L56.3286 44.0101C57.8042 41.33 62.1958 41.33 63.6714 44.0101L79.5968 72.939C80.8886 75.2856 78.9196 78 75.9254 78H44.0746C41.0804 78 39.1114 75.2856 40.4033 72.939Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54V62",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60 70.039V70",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeIcon);
export default __webpack_public_path__ + "static/media/noticeIcon.3b5363d22d2f059cbb2f8a28414e464c.svg";
export { ForwardRef as ReactComponent };